
const AboutHero = () => {
  return (
    <section 
      className="relative py-20 bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/bab54e650fd27295a4b88f0e8fadd532.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center text-white">
          <h1 className="text-5xl font-bold mb-6">
            Meet Our Expert Team
          </h1>
          <p className="text-xl max-w-3xl mx-auto leading-relaxed">
            Golden Black brings together world-class engineers and chemists with decades of experience 
            in oilfield chemical solutions, delivering innovative technologies that transform industry challenges into opportunities.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
